interface SellerCoverage {
  coverageKey?: string
}

/**
 * First visit for a user+seller combo enables the multi-seller interchange tooltip.
 */
export const shouldShowMultiSellerTooltip = (
  userId: string,
  sellerDetails?: SellerCoverage | null
): boolean => {
  if (!sellerDetails?.coverageKey) return false

  const key = `${userId}_multiseller_tooltip_display`
  const storedValue = localStorage.getItem(key)

  if (storedValue === null) {
    localStorage.setItem(key, 'true')
    return true
  }

  return storedValue === 'true'
}
